import dynamic from 'next/dynamic';

import QuickViewButton from './QuickViewButton';
import QuickViewContext, { useQuickViewContext } from './QuickViewContext';

const QuickViewModal = dynamic(() =>
  import(/* webpackChunkName: "QuickViewModal" */ './QuickViewModal')
);

const QuickView = {
  Context: QuickViewContext,
  Button: QuickViewButton,
  Modal: QuickViewModal,
  useContext: useQuickViewContext,
};

export default QuickView;
